// libraries
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import { MANAGER_VIEW_APP_PREFIX } from '@makemydeal/dr-shared-ui-utils';

// consts/enums
import { CONFIRM_PUSH_TO_ROUTEONE, PUSH_TO_FI } from '../actionTypes/pushToRouteOneActionTypes';

// actions
import {
    clearPushToRouteOneCache,
    pushToRouteOneRSAA,
    updatePushToRouteOneFailureStatus
} from '../actions/pushToRouteOneActionCreators';

// interfaces/types
import { type DashMiddleware, type DashStore, type DashNext } from '@makemydeal/dr-shared-store';
import { saveOffer } from '../actions/offerActionCreators';
import {
    LINKS_FAILURE,
    LINKS_SUCCESS,
    OFFER_SAVE_FAILURE,
    OFFER_SAVE_NOCHANGE_SUCCESS,
    OFFER_SAVE_SUCCESS,
    SOFT_SAVE_FAILURE,
    SOFT_SAVE_SUCCESS
} from '../actionTypes/offerActionTypes';

export const middleware: DashMiddleware = (store: DashStore) => (next: DashNext) => (action: AnyFSA) => {
    next(action);

    switch (action.type) {
        case CONFIRM_PUSH_TO_ROUTEONE:
            store.dispatch(clearPushToRouteOneCache());
            store.dispatch(saveOffer({ originalAction: CONFIRM_PUSH_TO_ROUTEONE, source: PUSH_TO_FI }));
            break;
        case LINKS_SUCCESS:
        case OFFER_SAVE_NOCHANGE_SUCCESS:
        case SOFT_SAVE_SUCCESS:
        case OFFER_SAVE_SUCCESS:
            if (action.meta?.source === PUSH_TO_FI) {
                const currentState = store.getState();
                const payloadOverrides = {
                    dealXgId: action.payload?.dealXgId,
                    dealXgVersion: action.payload?.dealXgVersion
                };
                store.dispatch(pushToRouteOneRSAA(MANAGER_VIEW_APP_PREFIX, currentState, payloadOverrides));
            }
            break;
        case LINKS_FAILURE:
        case SOFT_SAVE_FAILURE:
        case OFFER_SAVE_FAILURE:
            if (action.meta?.source === PUSH_TO_FI) {
                store.dispatch(updatePushToRouteOneFailureStatus());
            }
            break;
        default:
            break;
    }
};
